import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgesQuery, BadgesService } from '@fgb/core';
import { BadgeListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/badges/badge-list-item';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/loyalty/badges/badge-list-item';

const _c0 = function (a0) { return [a0]; };
function BadgeFeaturedListComponent_ng_container_0_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "h2", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 10);
    ɵngcc0.ɵɵelementStart(4, "span", 11);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "span", 12);
    ɵngcc0.ɵɵtext(7, "arrow_forward_ios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(3, _c0, ctx_r3.link));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.linkTitle);
} }
function BadgeFeaturedListComponent_ng_container_0_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "fgbcl-badge-list-item", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const badge_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("col-lg-2", ctx_r4.isList)("col-md-4", ctx_r4.isList)("col-6", ctx_r4.isList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("badge", badge_r5);
} }
function BadgeFeaturedListComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtemplate(2, BadgeFeaturedListComponent_ng_container_0_div_1_div_2_Template, 8, 5, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtemplate(5, BadgeFeaturedListComponent_ng_container_0_div_1_div_5_Template, 2, 7, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const badges_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showTitle);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", badges_r1);
} }
function BadgeFeaturedListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BadgeFeaturedListComponent_ng_container_0_div_1_Template, 6, 2, "div", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const badges_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", badges_r1 && badges_r1.length);
} }
class BadgeFeaturedListComponent {
    constructor(badgesQuery, badgesService) {
        this.badgesQuery = badgesQuery;
        this.badgesService = badgesService;
        this.title = 'Badges';
        this.showTitle = true;
        this.limit = 6;
        this.link = '/badges';
        this.linkTitle = 'Show All';
        this.isList = true;
    }
    ngOnInit() {
        this.badgesService.fetchBadges().toPromise();
        this.badges$ = this.badgesQuery.selectAllCompletedBadges(this.limit);
    }
}
BadgeFeaturedListComponent.ɵfac = function BadgeFeaturedListComponent_Factory(t) { return new (t || BadgeFeaturedListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BadgesQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BadgesService)); };
BadgeFeaturedListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BadgeFeaturedListComponent, selectors: [["fgbcl-badge-featured-list"]], inputs: { title: "title", showTitle: "showTitle", limit: "limit", link: "link", linkTitle: "linkTitle" }, decls: 2, vars: 3, consts: [[4, "ngIf"], ["class", "badge-featured-list", 4, "ngIf"], [1, "badge-featured-list"], [1, "badge-featured-list", "container", "mt-4"], ["class", "d-flex justify-content-between", 4, "ngIf"], [1, "badges-list-container"], [1, "row"], [3, "col-lg-2", "col-md-4", "col-6", 4, "ngFor", "ngForOf"], [1, "d-flex", "justify-content-between"], [1, "badge-featured-list-title"], [1, "d-flex", "align-items-center", "cursor-pointer", 3, "routerLink"], [1, "badge-featured-list-link"], ["aria-hidden", "true", 1, "icon", "material-icons", "pl-1", "font-size-14", "font-weight-bold"], [3, "badge"]], template: function BadgeFeaturedListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BadgeFeaturedListComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.badges$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.RouterLink, ɵngcc4.BadgeListItemComponent], pipes: [ɵngcc2.AsyncPipe], styles: [""] });
BadgeFeaturedListComponent.ctorParameters = () => [
    { type: BadgesQuery },
    { type: BadgesService }
];
BadgeFeaturedListComponent.propDecorators = {
    title: [{ type: Input }],
    showTitle: [{ type: Input }],
    limit: [{ type: Input }],
    link: [{ type: Input }],
    linkTitle: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeFeaturedListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-badge-featured-list',
                template: "<ng-container *ngIf=\"badges$ | async as badges\">\r\n  <div class=\"badge-featured-list\" *ngIf=\"badges && badges.length\">\r\n    <div class=\"badge-featured-list container mt-4\">\r\n      <!--Title and Navigation-->\r\n      <div class=\"d-flex justify-content-between\" *ngIf=\"showTitle\">\r\n        <h2 class=\"badge-featured-list-title\">{{ title }}</h2>\r\n        <div class=\"d-flex align-items-center cursor-pointer\" [routerLink]=\"[link]\">\r\n          <span class=\"badge-featured-list-link\">{{ linkTitle }}</span>\r\n          <span class=\"icon material-icons pl-1 font-size-14 font-weight-bold\" aria-hidden=\"true\">arrow_forward_ios</span>\r\n        </div>\r\n      </div>\r\n      <div class=\"badges-list-container\">\r\n        <!--Badge List-->\r\n        <div class=\"row\">\r\n          <div *ngFor=\"let badge of badges\" [class.col-lg-2]=\"isList\" [class.col-md-4]=\"isList\" [class.col-6]=\"isList\">\r\n            <fgbcl-badge-list-item [badge]=\"badge\"></fgbcl-badge-list-item>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.BadgesQuery }, { type: ɵngcc1.BadgesService }]; }, { title: [{
            type: Input
        }], showTitle: [{
            type: Input
        }], limit: [{
            type: Input
        }], link: [{
            type: Input
        }], linkTitle: [{
            type: Input
        }] }); })();

class BadgeFeaturedListModule {
}
BadgeFeaturedListModule.ɵfac = function BadgeFeaturedListModule_Factory(t) { return new (t || BadgeFeaturedListModule)(); };
BadgeFeaturedListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BadgeFeaturedListModule });
BadgeFeaturedListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            BadgeListItemModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BadgeFeaturedListModule, { declarations: function () { return [BadgeFeaturedListComponent]; }, imports: function () { return [CommonModule,
        BadgeListItemModule,
        RouterModule]; }, exports: function () { return [BadgeFeaturedListComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeFeaturedListModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BadgeFeaturedListComponent
                ],
                imports: [
                    CommonModule,
                    BadgeListItemModule,
                    RouterModule
                ],
                exports: [
                    BadgeFeaturedListComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeFeaturedListComponent, BadgeFeaturedListModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-badges-badge-featured-list.js.map